import { configureStore } from '@reduxjs/toolkit';
import snackReducer from './slices/snackSlice';
import configReducer from './slices/configSlice';
import targetReducer from './slices/targetSlice';
import userReducer from './slices/userSlice';
import registrationReducer from './slices/registrationSlice';
import leadFormReducer from './slices/leadFormSlice';

const store = configureStore({
    // Slice keys are kept on the legacy `*Reducer` names so the ~13 existing
    // useSelector reads (`state.snackReducer.snack`, etc.) don't need to churn.
    reducer: {
        snackReducer,
        configReducer,
        targetReducer,
        userReducer,
        registrationReducer,
        leadFormReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
